<template>
  <div class="footer">
    <div class="wd">
      <Row type="flex" justify="space-between">
        <i-col span="8">
          <p class="title">关于</p>
          <p style="width: 330px">
            少儿编程是受欢迎的儿童编码平台，成千上万的人在那里学习编码。少儿编程为孩子们提供了自定进度的在线课程，让他们在家学习编码，还为学校和营地专门设计了课程。
          </p>
        </i-col>
        <i-col span="1">
          <p class="title">资源</p>
          <p>博客</p>
          <p>微信</p>
          <p>伙伴</p>
          <p>论坛</p>
        </i-col>
        <i-col span="3">
          <p class="title">父母</p>
          <p>为什么要编码</p>
          <p>边玩边学编程</p>
          <p>培训班</p>
          <p>孩子如何学习编程</p>
        </i-col>
        <i-col span="2">
          <p class="title">教育者</p>
          <p>编程1小时</p>
          <p>学校课程</p>
          <p>STEAM项目</p>
          <p>共同核心</p>
        </i-col>
        <i-col span="4">
          <p class="title">保持联系</p>
          <div>
            <img src="@/assets/home/f.jpg" alt="" />
            <img src="@/assets/home/f1.jpg" alt="" />
            <img src="@/assets/home/f2.jpg" alt="" />
          </div>
          <p class="title">家长通讯</p>
          <i-input class="wx-input" placeholder="请输入微信号码">
            <a href="javascript:void(0)" slot="append">GO</a>
          </i-input>
        </i-col>
      </Row>
      <Row class="bottom" type="flex" justify="center">
        <i-col span="2" class="btm-tit">用户协议</i-col>
        <i-col span="2" class="btm-tit">隐私协议</i-col>
        <i-col span="2" class="btm-tit">免责声明</i-col>
        <i-col span="2" class="btm-tit">
          <a href="/">关于我们</a>
        </i-col>
        <i-col span="2" class="btm-tit">联系我们</i-col>
      </Row>
      <p style="text-align: center; margin-top: 10px">
        Copyright 2020 All Rights Reserved. 备案 :
        <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备12345678号</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  }
};
</script>
<style lang="scss">
.footer {
  .wx-input {
    .ivu-input {
      background-color: rgba(70, 76, 91, 0.6);
      border-color: rgba(202, 202, 202, 1);
      color: #fff;
    }
    .ivu-input-group-append {
      background-color: rgba(245, 154, 35, 1);
      color: #fff;
      border: none;
    }
  }
}
</style>
<style lang="scss" scoped>
.footer {
  padding: 30px 60px;
  // background: -webkit-linear-gradient(
  //   90deg,
  //   rgba(41, 147, 181, 1) -117%,
  //   rgba(105, 103, 206, 1) 129%
  // );
  background: #6376c7;
  color: rgb(234, 234, 234);
  text-align: left;
  font-size: 13px;
  font-family: "微软雅黑", sans-serif;
  .title {
    margin-bottom: 10px;
  }
  .bottom {
    border-top: 1px solid #f2f2f2;
    margin-top: 50px;
    .btm-tit {
      border-right: 1px solid #f2f2f2;
      text-align: center;
      margin-top: 5px;
      a {
        color: #f2f2f2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue